import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Question as QuestionMark } from '@zocdoc-frontend-common/assets-icons';
import { TOOLTIP, Tooltip } from '@zocdoc-frontend-common/components-tooltip';
import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import {
    EVENT_INITIATORS,
    INTERACTION_TYPES,
} from '@zocdoc-frontend-common/utils-frontend-metrics';
import { blue100, slate80 } from '@zocdoc-mezzanine/foundations-colors';
import { paragraphSmall } from '@zocdoc-mezzanine/foundations-typography';

const tooltipMessage1 =
    'Add information that would be helpful for the doctor to know, such as details about your current issue, your medical history, or your gender.';
const tooltipMessage2 =
    "We'll send these to your doctor, but there's a chance they may not reach them in a timely manner.";

/**
 * @description A tooltip that explains what kind of notes might be useful for the doctor
 * @param {function(params: Object): void} sendMetric
 * @returns {JSX.Element}
 * @constructor
 */
function BaseSexAssignedAtBirthTooltip({ sendMetric }) {
    const anchor = (
        <StyledQuestionMark
            color={slate80}
            height={16}
            data-test="sex-assigned-at-birth-tooltip-anchor"
        />
    );

    const handleViewTooltip = useCallback(() => {
        sendMetric({
            action: 'Viewed SexAssignedAtBirthTooltip',
        });
    }, [sendMetric]);

    return (
        <TooltipWrapper>
            <StyledTooltip
                anchor={anchor}
                data-test="sex-assigned-at-birth-tooltip"
                onViewTooltip={handleViewTooltip}
                showTooltipOnFocus
                showTooltipOnHover
                tooltipPosition={TOOLTIP.RIGHT}
            >
                <Message>{tooltipMessage1}</Message>
                <Message>{tooltipMessage2}</Message>
            </StyledTooltip>
        </TooltipWrapper>
    );
}

const Message = styled.p`
    color: ${blue100};
    margin-top: 22px;
    ${paragraphSmall}

    &:first-child {
        margin-top: 0;
    }
`;

const StyledQuestionMark = styled(QuestionMark)`
    margin-left: 8px;
`;

const StyledTooltip = styled(Tooltip)`
    width: 350px;
`;

const TooltipWrapper = styled.div`
    margin: auto 0;
`;

/**
 * @description A tooltip that explains what kind of notes might be useful for the doctor
 * @returns {JSX.Element}
 */
export const SexAssignedAtBirthTooltip = withCustomMetrics({
    component: 'SexAssignedAtBirthTooltip',
    element: 'SexAssignedAtBirthTooltip',
    initiator: EVENT_INITIATORS.USER,
    interactionType: INTERACTION_TYPES.VIEW,
})(BaseSexAssignedAtBirthTooltip);
